import { render, staticRenderFns } from "./AdmissionTypeSelectionForm.vue?vue&type=template&id=1f0a78df&scoped=true&"
import script from "./AdmissionTypeSelectionForm.vue?vue&type=script&lang=ts&"
export * from "./AdmissionTypeSelectionForm.vue?vue&type=script&lang=ts&"
import style0 from "./AdmissionTypeSelectionForm.vue?vue&type=style&index=0&id=1f0a78df&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1f0a78df",
  null
  
)

export default component.exports